<template>
  <div v-if="diffAvailable === false" class="unified-diff-empty">Diff is not available for this change.</div>
  <div v-else-if="hunks.length === 0" class="unified-diff-empty">No textual changes.</div>
  <div v-else class="unified-diff">
    <template v-for="hunk in hunks" :key="hunk.ordinal">
      <div
        v-for="(line, index) in parseHunk(hunk.unifiedText)"
        :key="`${hunk.ordinal}-${index}`"
        :class="['diff-line', `diff-line-${line.kind}`]"
      >{{ line.text }}</div>
    </template>
  </div>
</template>

<script setup lang="ts">
import type { DocumentDiffHunkResponse } from '../api/generated';

type DiffLineKind = 'header' | 'added' | 'removed' | 'context';

interface DiffLine {
  kind: DiffLineKind;
  text: string;
}

withDefaults(
  defineProps<{
    hunks: DocumentDiffHunkResponse[];
    diffAvailable?: boolean;
  }>(),
  {
    diffAvailable: true
  }
);

function classify(line: string): DiffLineKind {
  if (line.startsWith('@@')) {
    return 'header';
  }

  if (line.startsWith('+')) {
    return 'added';
  }

  if (line.startsWith('-')) {
    return 'removed';
  }

  return 'context';
}

function parseHunk(unifiedText: string): DiffLine[] {
  return unifiedText
    .replace(/\n$/, '')
    .split('\n')
    .map(line => ({ kind: classify(line), text: line.length > 0 ? line : ' ' }));
}
</script>
